import image1mb from 'images/speed-test/image-1mb.png'
import image4mb from 'images/speed-test/image-4mb.png'
import image9mb from 'images/speed-test/image-9mb.png'
import image35mb from 'images/speed-test/image-35mb.png'
import imageL from 'images/speed-test/image-l.gif'

class SpeedTestHelper {
  constructor() {
    this.images = [
      image1mb,
      image4mb,
      image9mb,
      image35mb
    ]
  }

  run(callback) {
    let numTestImages = 4,
      latencyResult = [],
      bandWidthResult = [],
      latency = null,
      averageBandwidth = null,
      latencyImageRandomId

    // Calculate latency
    // Fetch the same image twice
    // The difference in time spent fetching between the first and the second time is latency
    latencyImageRandomId = '?random=' + (+new Date())
    for (let ith = 0; ith < 2; ith++) {
      this.fetchLatencyTestImage(latencyImageRandomId, duration => {
        latencyResult.push(duration)

        if(latencyResult.length === 2) {
          latency = latencyResult[0] - latencyResult[1]
        }

        if(latency !== null && averageBandwidth !== null) {
          callback({latencyInMS: latency, bandwidthInMB: averageBandwidth})
        }
      })
    }

    // Calculate bandwidth
    // Images are fetched in increasing sizes.
    // Bandwidth is caclulated based on the average bandwidth of fetching a few test images.
    for (let ith = 0; ith < numTestImages; ith++) {
      this.fetchBandwidthTestImage(ith, speedMbps => {
        bandWidthResult.push(speedMbps)

        if(bandWidthResult.length === numTestImages) {
          // If the image is too small and therefore the start time is equal to the end time
          // and bandwidth is equal to Infinity (refer to fetchBandwidthTestImage),
          // exclude the result from average bandwidth calculation.
          let bandwidths

          bandwidths = bandWidthResult.filter(bandwidth => bandwidth !== 'Infinity')
          averageBandwidth = (bandwidths.reduce((previousValue, currentValue) => {
            return +previousValue + +currentValue
          }) / bandwidths.length).toFixed(2)

          if(latency !== null && averageBandwidth !== null) {
            callback({latencyInMS: latency, bandwidthInMB: averageBandwidth})
          }
        }
      })
    }
  }

  fetchBandwidthTestImage(imageIndex, callback) {
    let request = new XMLHttpRequest(),
      noCache,
      imageUrl,
      startTime,
      endTime

    noCache = '?nocache=' + (+new Date())
    imageUrl = window.location.protocol + '//' + window.location.host + this.images[imageIndex] + noCache
    startTime = +new Date()
    request.open('GET', imageUrl, true)

    request.onprogress = p => {
      console.log(p)
    }

    request.onreadystatechange = () => {
      let sizeInMB,
        duration,
        speedMbps

      if (request.readyState === 2) // request received
      {
        startTime = +new Date()
      }

      if (request.readyState === 4) // request finished and response is ready
      {
        endTime = +new Date()
        sizeInMB = request.getResponseHeader('Content-Length') * 8 / (1024 * 1024)
        duration = (endTime - startTime) / 1000
        speedMbps = (sizeInMB / duration).toFixed(2)

        callback(speedMbps)
      }
    }

    request.send()
  }

  fetchLatencyTestImage(noCache, callback) {
    let request = new XMLHttpRequest(),
      imageUrl,
      startTime,
      endTime

    imageUrl = window.location.protocol + '//' + window.location.host + imageL + noCache
    startTime = +new Date()
    request.open('GET', imageUrl, true)

    request.onreadystatechange = () => {
      let duration

      if (request.readyState === 2) // request received
      {
        startTime = +new Date()
      }

      if (request.readyState === 4) // request finished and response is ready
      {
        endTime = +new Date()
        duration = endTime - startTime // in ms
        callback(duration)
      }
    }

    request.send()
  }
}

export default SpeedTestHelper
